import { gql } from '../types/generated';

export const GET_SCHEDULE = gql(`
  query schedule($date: String = "", $sports: [Sport] = [MLB]) {
    schedule(date: $date, sports: $sports) {
      away {
        ...TeamFields
      }
      home {
        ...TeamFields
      }
      venue {
        id
        name
      }
      feeds {
        feedType
        postGameShow
        preGameShow
      }
      gameDate
      gamePk
      status
      content {
        callSign
        feedType
        gamePk
        mediaId
        mediaState {
          contentExperience
          mediaType
          state
        }
      }
      pipelines {
        id
        feedType
        programSource
        status
        scheduledStartDateTime
        streamState
        resumedFromDateTime
        pregameSource
        postgameSource
        gameSource
        media {
          id
          mediaType
          feedType
        }
      }
    }
  }
`);

export const AUDITS = gql(`
  query audits(
    $sourceSystems: [String!],
    $operations: [String!],
    $instigator: String,
    $email: String,
    $traceId: String,
    $startDate: String,
    $endDate: String,
    $tag: ResourceTagInput
    $limit: Int,
    $page: Int,
  ) {
    audits(
      sourceSystems: $sourceSystems,
      operations: $operations,
      instigator: $instigator,
      email: $email,
      traceId: $traceId,
      startDate: $startDate,
      endDate: $endDate,
      tag: $tag,
      limit: $limit,
      page: $page
    ) {
      audits {
        id
        createdAt
        sourceSystem
        operation
        instigator
        email
        traceId
        createdAt
        resourceTags {
          name
          value
        }
        eventData
      }
      total
    }
  }
`);

export const AUDIT_SOURCE_SYSTEMS = gql(`
  query auditSourceSystems {
    auditSourceSystems {
      name
      operations
    }
  }
`);
